import { Typography, Button, Box } from '@mui/material';
import Grid from 'components/core/Grid';

import { ContentFullBar, ContentFullBarInfo } from './styles';

export const FullInformationBar = ({
  title,
  message,
  buttonText,
  onClick,
}: {
  title: string;
  message?: string;
  buttonText?: string;
  onClick?: () => void;
}) => {
  return (
    <>
      <ContentFullBar>
        <ContentFullBarInfo container>
          <Grid item xs={12} sm={11} md={10} lg={7}>
            <Typography variant="h2" style={{ color: '#fff' }}>
              {title}
            </Typography>
            {message && <Typography mt={4}>{message}</Typography>}
            {buttonText && (
              <Box mt={4}>
                <Button onClick={onClick} variant="contained" size="large">
                  {buttonText}
                </Button>
              </Box>
            )}
          </Grid>
        </ContentFullBarInfo>
      </ContentFullBar>
    </>
  );
};
